import { DEFAULT_LOCALE } from '@/i18n/config';
import enTranslation from '@/i18n/translations/en.json';
import * as i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: enTranslation
  }
};

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: (typeof resources)['en'];
  }
}

void i18n.use(initReactI18next).init({
  resources,
  fallbackLng: DEFAULT_LOCALE,
  detection: {
    order: ['localStorage', 'navigator'],
    lookupFromPathIndex: 0
  },
  interpolation: {
    escapeValue: false
  }
});

export { i18n };

type RecursiveKeyOf<T> = T extends object
  ? {
      [K in keyof T]: T[K] extends object
        ? T[K] extends unknown[]
          ? K & string
          : RecursiveKeyOf<T[K]> extends infer R
            ? R extends string
              ? `${K & string}.${R}`
              : never
            : never
        : K & string;
    }[keyof T]
  : never;
export type TranslationKey = RecursiveKeyOf<i18n.CustomTypeOptions['resources']['translation']>;
